<template>
  <div class="register">
    <v-card v-if="pgUrl === null" class="mx-auto m-5" style="max-width: 40%">
      <v-card-title
        class="loginmain justify-center text-white"
        style="font-family: 'Nunito', sans-serif"
        >Quick Pay</v-card-title
      >
      <v-form class="mt-8 m-5" ref="form" v-model="valid" lazy-validation>
        <v-text-field
          style="backgorund-color: black"
          type="text"
          color="black"
          required
          label="Opentity"
          v-model="form.opentity"
          :disabled="disabled"
        />
        <v-text-field
          required
          label="Enter Your Mobile Number"
          v-model="form.mobileNo"
          :rules="mobileNoRules"
          type="number"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="10"
        />
        <v-text-field
          required
          label="Enter Your Email Id"
          type="text"
          v-model="form.email"
        />

        <div class="md:flex py-3 items-center">
          <div class="pr-2 font-semibold"></div>

          <div v-if="!!this.$route.params.accountNo">
            <!-- this is for STB -->
            <!-- <h5 style="color: green">Enter minimum-1/-</h5> -->
            <v-text-field
              type="text"
              v-model="form.amount"
              placeholder="Enter Your Amount Minimum-1/-"
              :rules="amountRules"
            />
            <v-btn
              class="rounded mx-auto d-block"
              @click="
                validate();
                handleSubmit();
              "
              :disabled="!checkIsPayableFor_stb_Account()"
              style="
                color: #59065d;
                border: 2px solid #59065d;
                padding: 10px 24px;
              "
              >Pay</v-btn
            >
          </div>

          <div v-if="!!this.$route.params.opentityCode">
            <!-- this is for OPENTITY account min 2000/- -->
            <!-- <h5 style="color: green">Enter minimum-2000/-</h5> -->
            <v-text-field
              type="text"
              v-model="form.amount"
              placeholder="Enter Your Amount Minimum-500/-"
              :rules="amountRules"
            />
            <v-btn
              class="rounded mx-auto d-block"
              @click="
                validate();
                handleSubmit();
              "
              :disabled="!checkIsPayableFor_opentiti_Account()"
              style="
                color: #59065d;
                border: 2px solid #59065d;
                padding: 10px 24px;
              "
              >Pay</v-btn
            >
          </div>
          <!--              <v-btn
                    class="rounded mx-auto d-block"
                    @click="validate(); handleSubmit();"
                    style="color:#59065d;border:2px solid #59065d;padding: 10px 24px; "
                  >Pay</v-btn>
              -->
        </div>
      </v-form>
    </v-card>
    <payment-start
      v-else
      :action="pgUrl"
      :params="pgParams"
      :checksum="checkSum"
    />
    <v-snackbar v-model="showMessage" :color="color">{{ msg }}</v-snackbar>
  </div>
</template>
<script>
import { extractError } from "../../utils/error";
import axios from "axios";
import PaymentStart from "@/components/Channel/Paymentstart.vue";
import { quickpay } from "../../services/quickpay";
import { getStatus as getStatusService } from "../../services/quickpay";
import { easebuzzPaymentStatusNew } from "../../services/quickpay";
import {
  getCount as getCountService,
  createEasyBuzzQuickPayRequest,
} from "../../services/quickpay";
import { EASY_BUZZ_URL } from "../../config";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  components: {
    PaymentStart,
  },
  data() {
    return {
      countResp: "",
      iseazebuzz: false,
      disabled: true,
      form: {
        opentity:
          this.$route.params.accountNo || this.$route.params.opentityCode,
        mobileNo: "",
        email: "",
        amount: "",
      },
      valid: true,
      showMessage: false,
      msg: "",
      color: "",
      amount: "",
      pgParams: {},
      pgUrl: null,
      checkSum: null,
      mobileNoRules: [(v) => !!v || "Mobile Number Is Required"],
      amountRules: [(v) => !!v || "Amount Is Required"],
      select: null,
      myValue: "",
      myValue1: "",
    };
  },
  props: {
    status: Boolean,
  },
  computed: {
    ...mapGetters("auth", ["monthlyCost"]),
    ...mapGetters("auth", ["isDP"]),
  },
  methods: {
    checkIsPayableFor_stb_Account() {
      return (
        this.form.amount > 0 &&
        this.form.mobileNo.length == 10 &&
        this.form.email
      );
    },

    checkIsPayableFor_opentiti_Account() {
      return (
        this.form.amount > 499 &&
        this.form.mobileNo.length == 10 &&
        this.form.email
      );
    },
    showSnack(msg, color) {
      this.msg = msg;
      this.color = color;
      this.showMessage = true;
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    async handleSubmit() {
      const resp = await getCountService();
      this.countResp = resp;
      this.proccedToPay();
    },
    //Initiating the payment gateway
    async proccedToPay() {
      // If the count is 0 then the paytm gateway will open
      if (this.countResp == 0) {
        sessionStorage.setItem("paymentGateway", "paytm");
        const { form, ...payload } = this.form;
        const result = await quickpay(payload);
        const {
          response: { redirect: REDIRECT_URL, parameters },
        } = result;
        // console.log({ REDIRECT_URL, parameters });
        const { CHECKSUMHASH, ...pgParams } = parameters;
        this.pgParams = pgParams;
        this.pgUrl = REDIRECT_URL;
        this.checkSum = CHECKSUMHASH;
        this.$nextTick(() => {
          document.f1.submit();
        });
      } else {
        try {
          sessionStorage.setItem("paymentGateway", "easebuzz");
          let amount = this.form.amount;
          let opentity = this.form.opentity;
          let email = this.form.email;
          let phone = this.form.mobileNo;
          let data = localStorage.getItem("in:user");
          let payload = {
            email: this.form.email,
            phone: this.form.mobileNo,
            productInfo: "Recharge",
            opentity: this.form.opentity,
            amount: this.form.amount,
          };
          this.iseazebuzz = true;
          let response = await createEasyBuzzQuickPayRequest(payload);
          if (response.data) {
            window.location.href = `${EASY_BUZZ_URL}/${response.data}`;
          } else {
            this.$swal({
              icon: "error",
              title: "Oops...",
              text: "Please try again",
            });
          }
        } catch (err) {}
      }
    },

    async easeBuzzStatusShow() {
      if (this.status === true) {
        const { id } = this.$route.params;
        const result = await easebuzzGetStatusService(id);
        if (result.status == "SUCCESS") {
          this.showSnack("Topup successful", "success");
        } else {
          this.showSnack("Topup failed", "error");
        }
      }
    },
    // ...mapActions("auth", ["getBalance"]),
  },
  async mounted() {
    //Getting the value from session storage
    var myValue = sessionStorage.getItem("paymentGateway");
    if (this.status === true) {
      if (myValue !== "easebuzz") {
        //Check the count by using the session storage service
        const { id } = this.$route.params;
        const result = await getStatusService(id);
        console.log("got status : ", result);
        const {
          response: {
            result: { status: transactionStatus },
          },
        } = result;
        console.log("got txn status : ", transactionStatus);
        if (transactionStatus == "TXN_SUCCESS") {
          this.showSnack("Quickpay successful", "success");
        } else {
          this.showSnack("Quickpay failed", "error");
        }
      } else {
        if (this.status === true) {
          const { id } = this.$route.params;
          const result = await easebuzzPaymentStatusNew(id);
          if (result.status == "SUCCESS") {
            this.showSnack("Quickpay successful", "success");
          } else {
            this.showSnack("Quickpay failed", "error");
          }
        }
      }
    }
  },
};
</script>
